import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4727dfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "临时用户", -1))
const _hoisted_2 = { class: "buttom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: true,
    title: "添加用户",
    width: "80%",
    "confirm-loading": _ctx.submiting,
    "destroy-on-close": true,
    "mask-closable": false,
    onOk: _ctx.onSubmit,
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formData,
        rules: _ctx.rules,
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "公司" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.enterpriseName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "部门",
            name: "departmentIds"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_table, {
            style: {"width":"100%"},
            "row-key": "id",
            columns: _ctx.tableColumns,
            loading: _ctx.loading,
            "data-source": _ctx.formData.tempAccountInfoList,
            bordered: "",
            pagination: false,
            class: "table"
          }, {
            index: _withCtx(({ index }) => [
              _createElementVNode("span", null, _toDisplayString(`用户${index + 1}`), 1)
            ]),
            userName: _withCtx(({ record, index }) => [
              _createVNode(_component_a_form_item, {
                name: ['tempAccountInfoList', index, 'userName'],
                rules: [{ required: true, message: '请输入姓名', trigger: ['change', 'blur'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: record.userName,
                    "onUpdate:value": ($event: any) => ((record.userName) = $event),
                    valueModifiers: { trim: true },
                    placeholder: "姓名",
                    maxlength: 32
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _: 2
              }, 1032, ["name"])
            ]),
            phone: _withCtx(({ record, index }) => [
              _createVNode(_component_a_form_item, {
                name: ['tempAccountInfoList', index, 'phone'],
                rules: [{ validator: _ctx.validatePhone, trigger: ['change', 'blur'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: record.phone,
                    "onUpdate:value": ($event: any) => ((record.phone) = $event),
                    placeholder: "手机号码"
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _: 2
              }, 1032, ["name", "rules"])
            ]),
            action: _withCtx(({ record, index}) => [
              _createElementVNode("div", _hoisted_2, [
                (index === _ctx.formData.tempAccountInfoList.length - 1 && index < 9)
                  ? (_openBlock(), _createBlock(_component_PlusCircleOutlined, {
                      key: 0,
                      onClick: ($event: any) => (_ctx.addRecord(record, index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (index > 0)
                  ? (_openBlock(), _createBlock(_component_MinusCircleOutlined, {
                      key: 1,
                      onClick: ($event: any) => (_ctx.deleteRecord(record, index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["columns", "loading", "data-source"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["confirm-loading", "onOk", "onCancel"]))
}